import React from "react";
import { Box, Stack } from "@mui/material";
import PropTypes from "prop-types";
import ChooseGrainsForm from "./ChooseGrainsForm";
import ChooseSpicesForm from "./ChooseSpicesForm";
import ChooseOilForm from "./ChooseOilForm";
import ChoosePasteForm from "./ChoosePasteForm";
import ChooseWaterForm from "./ChooseWaterForm";
import ChooseStirForm from "./ChooseStirForm";
import ChooseTimeForm from "./ChooseTimeForm";
import PourBowlForm from "./PourBowlForm";
import PourCupForm from "./PourCupForm";

export default function ChooseArgsForm({ task, onSubmit }) {
  const type = task.type;

  // Depending on the task type, render the corresponding form
  const renderForm = () => {
    switch (type) {
      case "choose_grains":
        return <ChooseGrainsForm task={task} onSubmit={onSubmit} />;
      case "choose_soaks":
        return <ChooseGrainsForm task={task} onSubmit={onSubmit} />;
      case "choose_spices":
        return <ChooseSpicesForm task={task} onSubmit={onSubmit} />;
      case "choose_oil":
        return <ChooseOilForm task={task} onSubmit={onSubmit} />;
      case "choose_paste":
        return <ChoosePasteForm task={task} onSubmit={onSubmit} />;
      case "choose_water":
        return <ChooseWaterForm task={task} onSubmit={onSubmit} />;
      case "choose_stir":
        return <ChooseStirForm task={task} onSubmit={onSubmit} />;
      case "choose_bowl":
        return <PourBowlForm task={task} onSubmit={onSubmit} />;
      case "choose_cup":
        return <PourCupForm task={task} onSubmit={onSubmit} />;
      case "choose_seconds":
      case "choose_minutes":
        return <ChooseTimeForm task={task} onSubmit={onSubmit} />;
      default:
        return <Box />;
    }
  };
  return <Stack spacing={2}>{renderForm()}</Stack>;
}

ChooseArgsForm.propTypes = {
  task: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

